import { useState } from 'react';
import { useQuery } from 'react-query';
import { Container } from 'Components/Container';
import { DefaultTable } from 'Components/DefaultTable';
import { ModalConfirmDelete } from 'Components/ModalConfirmDelete';
import { PageLoaderList } from 'Components/PageLoader/List';
import { tableHeader } from './table-header.js';
import { getGapAnalysisReport, deleteGapAnalysisReport } from 'services/gap-analysis.js';
import { useAuthTenant } from 'store/auth';
import { useSelector } from 'react-redux';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { NoData } from 'Components/NoData/index.jsx';
import { PageHelper } from 'Components/PageHelper';

const GapAnalysisReports = () => {
  const selectedTenant = useSelector(useAuthTenant);
  const SwalReact = withReactContent(Swal);
  const [open, setOpen] = useState(false);
  const [reFetch, setRefetch] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const {
    isLoading,
    error,
    data: reportData,
  } = useQuery(['getGapAnalysisReport', selectedTenant._id, reFetch], async () => {
    if (!selectedTenant._id) return { data: [] };
    const result = await getGapAnalysisReport(selectedTenant._id);
    return result.data;
  });


  const onDelete = item => {
    setItemToDelete(item);
    setOpen(true);
  };


  const onClose = () => {
    setItemToDelete(null);
    setOpen(false);
  };

  const onConfirm = async () => {
    try {
      const result = await deleteGapAnalysisReport(itemToDelete?._id);
      if (result.status === 204 || result.status === 200) {
        onClose();
        setRefetch(!reFetch);
      } else {
        throw new Error('Erro ao tentar remover o relatório!');
      }
    } catch (error) {
      SwalReact.fire({
        title: 'Erro!',
        text: error?.response?.data?.message ?? error.message,
        icon: 'error',
      });
    }
  };
  console.log(reportData);
  return (
    <Container 
      title="Relatórios Gap Analysis" 
      breadcrumb="Relatórios / Gap Analysis" 
      showButtonAdd
      data-tour="page-title"
      addButtonDataTour="add-button"
    >
      {isLoading && <PageLoaderList />}
      {error && <div>Ocorreu um erro ao carregar os relatórios.</div>}
      {!isLoading && !error && reportData?.length === 0 && (
        <NoData description={'Não há relatórios de Gap Analysis para exibir'} />
      )}
      {!isLoading && !error && reportData?.length > 0 && (
        <div className="container">
          <div data-tour="table">
            <DefaultTable
              rows={tableHeader}
              cells={reportData}
              onClickDelete={onDelete}
              hideEdit
              link="reports/gap-analysis"
            />
          </div>
          {/* Paginação real pode ser feita depois no backend */}
          <ModalConfirmDelete
            description={
              <>
                Tem certeza que deseja excluir o relatório <strong>{itemToDelete?.name}</strong>?
              </>
            }
            open={open}
            onClose={onClose}
            onConfirm={onConfirm}
          />
        </div>
      )}
      <PageHelper steps={tourSteps} tourKey="reports-gap-analysis" />
    </Container>
  );
};

const tourSteps = [
  {
    target: 'body',
    content: 'Bem-vindo aos Relatórios de Gap Analysis! Aqui você visualiza todos os relatórios de análise de lacunas de conformidade gerados.',
    disableBeacon: true,
    disableScrolling: true,
    placement: 'center',
  },
  {
    target: '[data-tour="page-title"]',
    content: 'Clique no título para voltar à página anterior.',
    disableScrolling: true,
  },
  {
    target: '[data-tour="add-button"]',
    content: 'Use o botão "Adicionar" para gerar um novo relatório de Gap Analysis e avaliar a conformidade da sua organização.',
    disableScrolling: true,
  },
  {
    target: '[data-tour="table"]',
    content: 'Esta tabela lista todos os relatórios de Gap Analysis. Clique em um relatório para visualizar detalhes completos do dashboard de análise.',
    disableScrolling: false,
  },
  {
    target: 'body',
    content: 'Tour concluído! Gere relatórios de Gap Analysis regularmente para monitorar o progresso da conformidade da sua organização.',
    disableScrolling: true,
    placement: 'center',
  },
];

export default GapAnalysisReports;
